/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestFieldsRouteImport } from './routes/test-fields'
import { Route as TestRouteImport } from './routes/test'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as DealershipsRouteImport } from './routes/dealerships'
import { Route as CreateDealershipRouteImport } from './routes/create-dealership'
import { Route as CompleteProfileRouteImport } from './routes/complete-profile'
import { Route as CheckDealershipRouteImport } from './routes/check-dealership'
import { Route as DealershipRouteRouteImport } from './routes/$dealership/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DealershipIndexRouteImport } from './routes/$dealership/index'
import { Route as FormTokenRouteImport } from './routes/form.$token'
import { Route as DealershipWebsiteRouteImport } from './routes/$dealership/website'
import { Route as DealershipTeamRouteImport } from './routes/$dealership/team'
import { Route as DealershipSettingsRouteImport } from './routes/$dealership/settings'
import { Route as DealershipInventoryRouteImport } from './routes/$dealership/inventory'
import { Route as DealershipFeatureRequestsRouteImport } from './routes/$dealership/feature-requests'
import { Route as DealershipDealPacketsRouteImport } from './routes/$dealership/deal-packets'
import { Route as DealershipDashboardRouteImport } from './routes/$dealership/dashboard'
import { Route as DealershipConversationsRouteImport } from './routes/$dealership/conversations'
import { Route as DealershipFeatureRequestsIndexRouteImport } from './routes/$dealership/feature-requests/index'
import { Route as DealershipDealPacketsIndexRouteImport } from './routes/$dealership/deal-packets/index'
import { Route as DealershipConversationsIndexRouteImport } from './routes/$dealership/conversations/index'
import { Route as DealershipInventoryVehicleIdRouteImport } from './routes/$dealership/inventory.$vehicleId'
import { Route as DealershipFeatureRequestsRequestIdRouteImport } from './routes/$dealership/feature-requests/$requestId'
import { Route as DealershipDocumentsTemplatesRouteImport } from './routes/$dealership/documents/templates'
import { Route as DealershipDocumentsNewRouteImport } from './routes/$dealership/documents/new'
import { Route as DealershipDocumentsTemplateIdRouteImport } from './routes/$dealership/documents/$templateId'
import { Route as DealershipDealPacketsTemplatesRouteImport } from './routes/$dealership/deal-packets/templates'
import { Route as DealershipDealPacketsPresetsRouteImport } from './routes/$dealership/deal-packets/presets'
import { Route as DealershipDealPacketsNewRouteImport } from './routes/$dealership/deal-packets/new'
import { Route as DealershipDealPacketsDealIdRouteImport } from './routes/$dealership/deal-packets/$dealId'
import { Route as DealershipConversationsThreadIdRouteImport } from './routes/$dealership/conversations/$threadId'
import { Route as DealershipFeatureRequestsRequestIdIndexRouteImport } from './routes/$dealership/feature-requests/$requestId.index'
import { Route as DealershipDocumentsTemplateIdIndexRouteImport } from './routes/$dealership/documents/$templateId.index'
import { Route as DealershipDealPacketsTemplatesIndexRouteImport } from './routes/$dealership/deal-packets/templates/index'
import { Route as DealershipDealPacketsPresetsIndexRouteImport } from './routes/$dealership/deal-packets/presets/index'
import { Route as DealershipDealPacketsDealIdIndexRouteImport } from './routes/$dealership/deal-packets/$dealId.index'
import { Route as DealershipConversationsThreadIdIndexRouteImport } from './routes/$dealership/conversations/$threadId.index'
import { Route as DealershipDocumentsTemplateIdFieldsRouteImport } from './routes/$dealership/documents/$templateId.fields'
import { Route as DealershipDealPacketsTemplatesTemplateIdRouteImport } from './routes/$dealership/deal-packets/templates/$templateId'
import { Route as DealershipDealPacketsTemplatesTemplateIdIndexRouteImport } from './routes/$dealership/deal-packets/templates/$templateId.index'
import { Route as DealershipDealPacketsTemplatesTemplateIdFieldsRouteImport } from './routes/$dealership/deal-packets/templates/$templateId.fields'

const SignupLazyRouteImport = createFileRoute('/signup')()
const ForgotPasswordLazyRouteImport = createFileRoute('/forgot-password')()
const DealershipSeoLazyRouteImport = createFileRoute('/$dealership/seo')()
const DealershipCustomersLazyRouteImport = createFileRoute(
  '/$dealership/customers',
)()
const DealershipAppointmentsLazyRouteImport = createFileRoute(
  '/$dealership/appointments',
)()
const DealershipAnalyticsLazyRouteImport = createFileRoute(
  '/$dealership/analytics',
)()
const DealershipInventoryIndexLazyRouteImport = createFileRoute(
  '/$dealership/inventory/',
)()

const SignupLazyRoute = SignupLazyRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/signup.lazy').then((d) => d.Route))
const ForgotPasswordLazyRoute = ForgotPasswordLazyRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/forgot-password.lazy').then((d) => d.Route),
)
const TestFieldsRoute = TestFieldsRouteImport.update({
  id: '/test-fields',
  path: '/test-fields',
  getParentRoute: () => rootRouteImport,
} as any)
const TestRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const DealershipsRoute = DealershipsRouteImport.update({
  id: '/dealerships',
  path: '/dealerships',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateDealershipRoute = CreateDealershipRouteImport.update({
  id: '/create-dealership',
  path: '/create-dealership',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteProfileRoute = CompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckDealershipRoute = CheckDealershipRouteImport.update({
  id: '/check-dealership',
  path: '/check-dealership',
  getParentRoute: () => rootRouteImport,
} as any)
const DealershipRouteRoute = DealershipRouteRouteImport.update({
  id: '/$dealership',
  path: '/$dealership',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DealershipIndexRoute = DealershipIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DealershipRouteRoute,
} as any)
const DealershipSeoLazyRoute = DealershipSeoLazyRouteImport.update({
  id: '/seo',
  path: '/seo',
  getParentRoute: () => DealershipRouteRoute,
} as any).lazy(() =>
  import('./routes/$dealership/seo.lazy').then((d) => d.Route),
)
const DealershipCustomersLazyRoute = DealershipCustomersLazyRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => DealershipRouteRoute,
} as any).lazy(() =>
  import('./routes/$dealership/customers.lazy').then((d) => d.Route),
)
const DealershipAppointmentsLazyRoute =
  DealershipAppointmentsLazyRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => DealershipRouteRoute,
  } as any).lazy(() =>
    import('./routes/$dealership/appointments.lazy').then((d) => d.Route),
  )
const DealershipAnalyticsLazyRoute = DealershipAnalyticsLazyRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => DealershipRouteRoute,
} as any).lazy(() =>
  import('./routes/$dealership/analytics.lazy').then((d) => d.Route),
)
const FormTokenRoute = FormTokenRouteImport.update({
  id: '/form/$token',
  path: '/form/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DealershipWebsiteRoute = DealershipWebsiteRouteImport.update({
  id: '/website',
  path: '/website',
  getParentRoute: () => DealershipRouteRoute,
} as any)
const DealershipTeamRoute = DealershipTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => DealershipRouteRoute,
} as any).lazy(() =>
  import('./routes/$dealership/team.lazy').then((d) => d.Route),
)
const DealershipSettingsRoute = DealershipSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DealershipRouteRoute,
} as any).lazy(() =>
  import('./routes/$dealership/settings.lazy').then((d) => d.Route),
)
const DealershipInventoryRoute = DealershipInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => DealershipRouteRoute,
} as any)
const DealershipFeatureRequestsRoute =
  DealershipFeatureRequestsRouteImport.update({
    id: '/feature-requests',
    path: '/feature-requests',
    getParentRoute: () => DealershipRouteRoute,
  } as any)
const DealershipDealPacketsRoute = DealershipDealPacketsRouteImport.update({
  id: '/deal-packets',
  path: '/deal-packets',
  getParentRoute: () => DealershipRouteRoute,
} as any)
const DealershipDashboardRoute = DealershipDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => DealershipRouteRoute,
} as any)
const DealershipConversationsRoute = DealershipConversationsRouteImport.update({
  id: '/conversations',
  path: '/conversations',
  getParentRoute: () => DealershipRouteRoute,
} as any)
const DealershipInventoryIndexLazyRoute =
  DealershipInventoryIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipInventoryRoute,
  } as any).lazy(() =>
    import('./routes/$dealership/inventory.index.lazy').then((d) => d.Route),
  )
const DealershipFeatureRequestsIndexRoute =
  DealershipFeatureRequestsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipFeatureRequestsRoute,
  } as any)
const DealershipDealPacketsIndexRoute =
  DealershipDealPacketsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipDealPacketsRoute,
  } as any)
const DealershipConversationsIndexRoute =
  DealershipConversationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipConversationsRoute,
  } as any)
const DealershipInventoryVehicleIdRoute =
  DealershipInventoryVehicleIdRouteImport.update({
    id: '/$vehicleId',
    path: '/$vehicleId',
    getParentRoute: () => DealershipInventoryRoute,
  } as any)
const DealershipFeatureRequestsRequestIdRoute =
  DealershipFeatureRequestsRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => DealershipFeatureRequestsRoute,
  } as any)
const DealershipDocumentsTemplatesRoute =
  DealershipDocumentsTemplatesRouteImport.update({
    id: '/documents/templates',
    path: '/documents/templates',
    getParentRoute: () => DealershipRouteRoute,
  } as any)
const DealershipDocumentsNewRoute = DealershipDocumentsNewRouteImport.update({
  id: '/documents/new',
  path: '/documents/new',
  getParentRoute: () => DealershipRouteRoute,
} as any)
const DealershipDocumentsTemplateIdRoute =
  DealershipDocumentsTemplateIdRouteImport.update({
    id: '/documents/$templateId',
    path: '/documents/$templateId',
    getParentRoute: () => DealershipRouteRoute,
  } as any)
const DealershipDealPacketsTemplatesRoute =
  DealershipDealPacketsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => DealershipDealPacketsRoute,
  } as any)
const DealershipDealPacketsPresetsRoute =
  DealershipDealPacketsPresetsRouteImport.update({
    id: '/presets',
    path: '/presets',
    getParentRoute: () => DealershipDealPacketsRoute,
  } as any)
const DealershipDealPacketsNewRoute =
  DealershipDealPacketsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DealershipDealPacketsRoute,
  } as any)
const DealershipDealPacketsDealIdRoute =
  DealershipDealPacketsDealIdRouteImport.update({
    id: '/$dealId',
    path: '/$dealId',
    getParentRoute: () => DealershipDealPacketsRoute,
  } as any)
const DealershipConversationsThreadIdRoute =
  DealershipConversationsThreadIdRouteImport.update({
    id: '/$threadId',
    path: '/$threadId',
    getParentRoute: () => DealershipConversationsRoute,
  } as any)
const DealershipFeatureRequestsRequestIdIndexRoute =
  DealershipFeatureRequestsRequestIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipFeatureRequestsRequestIdRoute,
  } as any)
const DealershipDocumentsTemplateIdIndexRoute =
  DealershipDocumentsTemplateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipDocumentsTemplateIdRoute,
  } as any)
const DealershipDealPacketsTemplatesIndexRoute =
  DealershipDealPacketsTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipDealPacketsTemplatesRoute,
  } as any)
const DealershipDealPacketsPresetsIndexRoute =
  DealershipDealPacketsPresetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipDealPacketsPresetsRoute,
  } as any)
const DealershipDealPacketsDealIdIndexRoute =
  DealershipDealPacketsDealIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipDealPacketsDealIdRoute,
  } as any)
const DealershipConversationsThreadIdIndexRoute =
  DealershipConversationsThreadIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipConversationsThreadIdRoute,
  } as any)
const DealershipDocumentsTemplateIdFieldsRoute =
  DealershipDocumentsTemplateIdFieldsRouteImport.update({
    id: '/fields',
    path: '/fields',
    getParentRoute: () => DealershipDocumentsTemplateIdRoute,
  } as any)
const DealershipDealPacketsTemplatesTemplateIdRoute =
  DealershipDealPacketsTemplatesTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => DealershipDealPacketsTemplatesRoute,
  } as any)
const DealershipDealPacketsTemplatesTemplateIdIndexRoute =
  DealershipDealPacketsTemplatesTemplateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DealershipDealPacketsTemplatesTemplateIdRoute,
  } as any)
const DealershipDealPacketsTemplatesTemplateIdFieldsRoute =
  DealershipDealPacketsTemplatesTemplateIdFieldsRouteImport.update({
    id: '/fields',
    path: '/fields',
    getParentRoute: () => DealershipDealPacketsTemplatesTemplateIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$dealership': typeof DealershipRouteRouteWithChildren
  '/check-dealership': typeof CheckDealershipRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/create-dealership': typeof CreateDealershipRoute
  '/dealerships': typeof DealershipsRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/reset-password': typeof ResetPasswordRoute
  '/test': typeof TestRoute
  '/test-fields': typeof TestFieldsRoute
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/signup': typeof SignupLazyRoute
  '/$dealership/conversations': typeof DealershipConversationsRouteWithChildren
  '/$dealership/dashboard': typeof DealershipDashboardRoute
  '/$dealership/deal-packets': typeof DealershipDealPacketsRouteWithChildren
  '/$dealership/feature-requests': typeof DealershipFeatureRequestsRouteWithChildren
  '/$dealership/inventory': typeof DealershipInventoryRouteWithChildren
  '/$dealership/settings': typeof DealershipSettingsRoute
  '/$dealership/team': typeof DealershipTeamRoute
  '/$dealership/website': typeof DealershipWebsiteRoute
  '/form/$token': typeof FormTokenRoute
  '/$dealership/analytics': typeof DealershipAnalyticsLazyRoute
  '/$dealership/appointments': typeof DealershipAppointmentsLazyRoute
  '/$dealership/customers': typeof DealershipCustomersLazyRoute
  '/$dealership/seo': typeof DealershipSeoLazyRoute
  '/$dealership/': typeof DealershipIndexRoute
  '/$dealership/conversations/$threadId': typeof DealershipConversationsThreadIdRouteWithChildren
  '/$dealership/deal-packets/$dealId': typeof DealershipDealPacketsDealIdRouteWithChildren
  '/$dealership/deal-packets/new': typeof DealershipDealPacketsNewRoute
  '/$dealership/deal-packets/presets': typeof DealershipDealPacketsPresetsRouteWithChildren
  '/$dealership/deal-packets/templates': typeof DealershipDealPacketsTemplatesRouteWithChildren
  '/$dealership/documents/$templateId': typeof DealershipDocumentsTemplateIdRouteWithChildren
  '/$dealership/documents/new': typeof DealershipDocumentsNewRoute
  '/$dealership/documents/templates': typeof DealershipDocumentsTemplatesRoute
  '/$dealership/feature-requests/$requestId': typeof DealershipFeatureRequestsRequestIdRouteWithChildren
  '/$dealership/inventory/$vehicleId': typeof DealershipInventoryVehicleIdRoute
  '/$dealership/conversations/': typeof DealershipConversationsIndexRoute
  '/$dealership/deal-packets/': typeof DealershipDealPacketsIndexRoute
  '/$dealership/feature-requests/': typeof DealershipFeatureRequestsIndexRoute
  '/$dealership/inventory/': typeof DealershipInventoryIndexLazyRoute
  '/$dealership/deal-packets/templates/$templateId': typeof DealershipDealPacketsTemplatesTemplateIdRouteWithChildren
  '/$dealership/documents/$templateId/fields': typeof DealershipDocumentsTemplateIdFieldsRoute
  '/$dealership/conversations/$threadId/': typeof DealershipConversationsThreadIdIndexRoute
  '/$dealership/deal-packets/$dealId/': typeof DealershipDealPacketsDealIdIndexRoute
  '/$dealership/deal-packets/presets/': typeof DealershipDealPacketsPresetsIndexRoute
  '/$dealership/deal-packets/templates/': typeof DealershipDealPacketsTemplatesIndexRoute
  '/$dealership/documents/$templateId/': typeof DealershipDocumentsTemplateIdIndexRoute
  '/$dealership/feature-requests/$requestId/': typeof DealershipFeatureRequestsRequestIdIndexRoute
  '/$dealership/deal-packets/templates/$templateId/fields': typeof DealershipDealPacketsTemplatesTemplateIdFieldsRoute
  '/$dealership/deal-packets/templates/$templateId/': typeof DealershipDealPacketsTemplatesTemplateIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/check-dealership': typeof CheckDealershipRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/create-dealership': typeof CreateDealershipRoute
  '/dealerships': typeof DealershipsRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/reset-password': typeof ResetPasswordRoute
  '/test': typeof TestRoute
  '/test-fields': typeof TestFieldsRoute
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/signup': typeof SignupLazyRoute
  '/$dealership/dashboard': typeof DealershipDashboardRoute
  '/$dealership/settings': typeof DealershipSettingsRoute
  '/$dealership/team': typeof DealershipTeamRoute
  '/$dealership/website': typeof DealershipWebsiteRoute
  '/form/$token': typeof FormTokenRoute
  '/$dealership/analytics': typeof DealershipAnalyticsLazyRoute
  '/$dealership/appointments': typeof DealershipAppointmentsLazyRoute
  '/$dealership/customers': typeof DealershipCustomersLazyRoute
  '/$dealership/seo': typeof DealershipSeoLazyRoute
  '/$dealership': typeof DealershipIndexRoute
  '/$dealership/deal-packets/new': typeof DealershipDealPacketsNewRoute
  '/$dealership/documents/new': typeof DealershipDocumentsNewRoute
  '/$dealership/documents/templates': typeof DealershipDocumentsTemplatesRoute
  '/$dealership/inventory/$vehicleId': typeof DealershipInventoryVehicleIdRoute
  '/$dealership/conversations': typeof DealershipConversationsIndexRoute
  '/$dealership/deal-packets': typeof DealershipDealPacketsIndexRoute
  '/$dealership/feature-requests': typeof DealershipFeatureRequestsIndexRoute
  '/$dealership/inventory': typeof DealershipInventoryIndexLazyRoute
  '/$dealership/documents/$templateId/fields': typeof DealershipDocumentsTemplateIdFieldsRoute
  '/$dealership/conversations/$threadId': typeof DealershipConversationsThreadIdIndexRoute
  '/$dealership/deal-packets/$dealId': typeof DealershipDealPacketsDealIdIndexRoute
  '/$dealership/deal-packets/presets': typeof DealershipDealPacketsPresetsIndexRoute
  '/$dealership/deal-packets/templates': typeof DealershipDealPacketsTemplatesIndexRoute
  '/$dealership/documents/$templateId': typeof DealershipDocumentsTemplateIdIndexRoute
  '/$dealership/feature-requests/$requestId': typeof DealershipFeatureRequestsRequestIdIndexRoute
  '/$dealership/deal-packets/templates/$templateId/fields': typeof DealershipDealPacketsTemplatesTemplateIdFieldsRoute
  '/$dealership/deal-packets/templates/$templateId': typeof DealershipDealPacketsTemplatesTemplateIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$dealership': typeof DealershipRouteRouteWithChildren
  '/check-dealership': typeof CheckDealershipRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/create-dealership': typeof CreateDealershipRoute
  '/dealerships': typeof DealershipsRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/reset-password': typeof ResetPasswordRoute
  '/test': typeof TestRoute
  '/test-fields': typeof TestFieldsRoute
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/signup': typeof SignupLazyRoute
  '/$dealership/conversations': typeof DealershipConversationsRouteWithChildren
  '/$dealership/dashboard': typeof DealershipDashboardRoute
  '/$dealership/deal-packets': typeof DealershipDealPacketsRouteWithChildren
  '/$dealership/feature-requests': typeof DealershipFeatureRequestsRouteWithChildren
  '/$dealership/inventory': typeof DealershipInventoryRouteWithChildren
  '/$dealership/settings': typeof DealershipSettingsRoute
  '/$dealership/team': typeof DealershipTeamRoute
  '/$dealership/website': typeof DealershipWebsiteRoute
  '/form/$token': typeof FormTokenRoute
  '/$dealership/analytics': typeof DealershipAnalyticsLazyRoute
  '/$dealership/appointments': typeof DealershipAppointmentsLazyRoute
  '/$dealership/customers': typeof DealershipCustomersLazyRoute
  '/$dealership/seo': typeof DealershipSeoLazyRoute
  '/$dealership/': typeof DealershipIndexRoute
  '/$dealership/conversations/$threadId': typeof DealershipConversationsThreadIdRouteWithChildren
  '/$dealership/deal-packets/$dealId': typeof DealershipDealPacketsDealIdRouteWithChildren
  '/$dealership/deal-packets/new': typeof DealershipDealPacketsNewRoute
  '/$dealership/deal-packets/presets': typeof DealershipDealPacketsPresetsRouteWithChildren
  '/$dealership/deal-packets/templates': typeof DealershipDealPacketsTemplatesRouteWithChildren
  '/$dealership/documents/$templateId': typeof DealershipDocumentsTemplateIdRouteWithChildren
  '/$dealership/documents/new': typeof DealershipDocumentsNewRoute
  '/$dealership/documents/templates': typeof DealershipDocumentsTemplatesRoute
  '/$dealership/feature-requests/$requestId': typeof DealershipFeatureRequestsRequestIdRouteWithChildren
  '/$dealership/inventory/$vehicleId': typeof DealershipInventoryVehicleIdRoute
  '/$dealership/conversations/': typeof DealershipConversationsIndexRoute
  '/$dealership/deal-packets/': typeof DealershipDealPacketsIndexRoute
  '/$dealership/feature-requests/': typeof DealershipFeatureRequestsIndexRoute
  '/$dealership/inventory/': typeof DealershipInventoryIndexLazyRoute
  '/$dealership/deal-packets/templates/$templateId': typeof DealershipDealPacketsTemplatesTemplateIdRouteWithChildren
  '/$dealership/documents/$templateId/fields': typeof DealershipDocumentsTemplateIdFieldsRoute
  '/$dealership/conversations/$threadId/': typeof DealershipConversationsThreadIdIndexRoute
  '/$dealership/deal-packets/$dealId/': typeof DealershipDealPacketsDealIdIndexRoute
  '/$dealership/deal-packets/presets/': typeof DealershipDealPacketsPresetsIndexRoute
  '/$dealership/deal-packets/templates/': typeof DealershipDealPacketsTemplatesIndexRoute
  '/$dealership/documents/$templateId/': typeof DealershipDocumentsTemplateIdIndexRoute
  '/$dealership/feature-requests/$requestId/': typeof DealershipFeatureRequestsRequestIdIndexRoute
  '/$dealership/deal-packets/templates/$templateId/fields': typeof DealershipDealPacketsTemplatesTemplateIdFieldsRoute
  '/$dealership/deal-packets/templates/$templateId/': typeof DealershipDealPacketsTemplatesTemplateIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$dealership'
    | '/check-dealership'
    | '/complete-profile'
    | '/create-dealership'
    | '/dealerships'
    | '/demo'
    | '/login'
    | '/logout'
    | '/reset-password'
    | '/test'
    | '/test-fields'
    | '/forgot-password'
    | '/signup'
    | '/$dealership/conversations'
    | '/$dealership/dashboard'
    | '/$dealership/deal-packets'
    | '/$dealership/feature-requests'
    | '/$dealership/inventory'
    | '/$dealership/settings'
    | '/$dealership/team'
    | '/$dealership/website'
    | '/form/$token'
    | '/$dealership/analytics'
    | '/$dealership/appointments'
    | '/$dealership/customers'
    | '/$dealership/seo'
    | '/$dealership/'
    | '/$dealership/conversations/$threadId'
    | '/$dealership/deal-packets/$dealId'
    | '/$dealership/deal-packets/new'
    | '/$dealership/deal-packets/presets'
    | '/$dealership/deal-packets/templates'
    | '/$dealership/documents/$templateId'
    | '/$dealership/documents/new'
    | '/$dealership/documents/templates'
    | '/$dealership/feature-requests/$requestId'
    | '/$dealership/inventory/$vehicleId'
    | '/$dealership/conversations/'
    | '/$dealership/deal-packets/'
    | '/$dealership/feature-requests/'
    | '/$dealership/inventory/'
    | '/$dealership/deal-packets/templates/$templateId'
    | '/$dealership/documents/$templateId/fields'
    | '/$dealership/conversations/$threadId/'
    | '/$dealership/deal-packets/$dealId/'
    | '/$dealership/deal-packets/presets/'
    | '/$dealership/deal-packets/templates/'
    | '/$dealership/documents/$templateId/'
    | '/$dealership/feature-requests/$requestId/'
    | '/$dealership/deal-packets/templates/$templateId/fields'
    | '/$dealership/deal-packets/templates/$templateId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/check-dealership'
    | '/complete-profile'
    | '/create-dealership'
    | '/dealerships'
    | '/demo'
    | '/login'
    | '/logout'
    | '/reset-password'
    | '/test'
    | '/test-fields'
    | '/forgot-password'
    | '/signup'
    | '/$dealership/dashboard'
    | '/$dealership/settings'
    | '/$dealership/team'
    | '/$dealership/website'
    | '/form/$token'
    | '/$dealership/analytics'
    | '/$dealership/appointments'
    | '/$dealership/customers'
    | '/$dealership/seo'
    | '/$dealership'
    | '/$dealership/deal-packets/new'
    | '/$dealership/documents/new'
    | '/$dealership/documents/templates'
    | '/$dealership/inventory/$vehicleId'
    | '/$dealership/conversations'
    | '/$dealership/deal-packets'
    | '/$dealership/feature-requests'
    | '/$dealership/inventory'
    | '/$dealership/documents/$templateId/fields'
    | '/$dealership/conversations/$threadId'
    | '/$dealership/deal-packets/$dealId'
    | '/$dealership/deal-packets/presets'
    | '/$dealership/deal-packets/templates'
    | '/$dealership/documents/$templateId'
    | '/$dealership/feature-requests/$requestId'
    | '/$dealership/deal-packets/templates/$templateId/fields'
    | '/$dealership/deal-packets/templates/$templateId'
  id:
    | '__root__'
    | '/'
    | '/$dealership'
    | '/check-dealership'
    | '/complete-profile'
    | '/create-dealership'
    | '/dealerships'
    | '/demo'
    | '/login'
    | '/logout'
    | '/reset-password'
    | '/test'
    | '/test-fields'
    | '/forgot-password'
    | '/signup'
    | '/$dealership/conversations'
    | '/$dealership/dashboard'
    | '/$dealership/deal-packets'
    | '/$dealership/feature-requests'
    | '/$dealership/inventory'
    | '/$dealership/settings'
    | '/$dealership/team'
    | '/$dealership/website'
    | '/form/$token'
    | '/$dealership/analytics'
    | '/$dealership/appointments'
    | '/$dealership/customers'
    | '/$dealership/seo'
    | '/$dealership/'
    | '/$dealership/conversations/$threadId'
    | '/$dealership/deal-packets/$dealId'
    | '/$dealership/deal-packets/new'
    | '/$dealership/deal-packets/presets'
    | '/$dealership/deal-packets/templates'
    | '/$dealership/documents/$templateId'
    | '/$dealership/documents/new'
    | '/$dealership/documents/templates'
    | '/$dealership/feature-requests/$requestId'
    | '/$dealership/inventory/$vehicleId'
    | '/$dealership/conversations/'
    | '/$dealership/deal-packets/'
    | '/$dealership/feature-requests/'
    | '/$dealership/inventory/'
    | '/$dealership/deal-packets/templates/$templateId'
    | '/$dealership/documents/$templateId/fields'
    | '/$dealership/conversations/$threadId/'
    | '/$dealership/deal-packets/$dealId/'
    | '/$dealership/deal-packets/presets/'
    | '/$dealership/deal-packets/templates/'
    | '/$dealership/documents/$templateId/'
    | '/$dealership/feature-requests/$requestId/'
    | '/$dealership/deal-packets/templates/$templateId/fields'
    | '/$dealership/deal-packets/templates/$templateId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DealershipRouteRoute: typeof DealershipRouteRouteWithChildren
  CheckDealershipRoute: typeof CheckDealershipRoute
  CompleteProfileRoute: typeof CompleteProfileRoute
  CreateDealershipRoute: typeof CreateDealershipRoute
  DealershipsRoute: typeof DealershipsRoute
  DemoRoute: typeof DemoRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TestRoute: typeof TestRoute
  TestFieldsRoute: typeof TestFieldsRoute
  ForgotPasswordLazyRoute: typeof ForgotPasswordLazyRoute
  SignupLazyRoute: typeof SignupLazyRoute
  FormTokenRoute: typeof FormTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-fields': {
      id: '/test-fields'
      path: '/test-fields'
      fullPath: '/test-fields'
      preLoaderRoute: typeof TestFieldsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dealerships': {
      id: '/dealerships'
      path: '/dealerships'
      fullPath: '/dealerships'
      preLoaderRoute: typeof DealershipsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-dealership': {
      id: '/create-dealership'
      path: '/create-dealership'
      fullPath: '/create-dealership'
      preLoaderRoute: typeof CreateDealershipRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-profile': {
      id: '/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof CompleteProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-dealership': {
      id: '/check-dealership'
      path: '/check-dealership'
      fullPath: '/check-dealership'
      preLoaderRoute: typeof CheckDealershipRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$dealership': {
      id: '/$dealership'
      path: '/$dealership'
      fullPath: '/$dealership'
      preLoaderRoute: typeof DealershipRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$dealership/': {
      id: '/$dealership/'
      path: '/'
      fullPath: '/$dealership/'
      preLoaderRoute: typeof DealershipIndexRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/seo': {
      id: '/$dealership/seo'
      path: '/seo'
      fullPath: '/$dealership/seo'
      preLoaderRoute: typeof DealershipSeoLazyRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/customers': {
      id: '/$dealership/customers'
      path: '/customers'
      fullPath: '/$dealership/customers'
      preLoaderRoute: typeof DealershipCustomersLazyRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/appointments': {
      id: '/$dealership/appointments'
      path: '/appointments'
      fullPath: '/$dealership/appointments'
      preLoaderRoute: typeof DealershipAppointmentsLazyRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/analytics': {
      id: '/$dealership/analytics'
      path: '/analytics'
      fullPath: '/$dealership/analytics'
      preLoaderRoute: typeof DealershipAnalyticsLazyRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/form/$token': {
      id: '/form/$token'
      path: '/form/$token'
      fullPath: '/form/$token'
      preLoaderRoute: typeof FormTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$dealership/website': {
      id: '/$dealership/website'
      path: '/website'
      fullPath: '/$dealership/website'
      preLoaderRoute: typeof DealershipWebsiteRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/team': {
      id: '/$dealership/team'
      path: '/team'
      fullPath: '/$dealership/team'
      preLoaderRoute: typeof DealershipTeamRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/settings': {
      id: '/$dealership/settings'
      path: '/settings'
      fullPath: '/$dealership/settings'
      preLoaderRoute: typeof DealershipSettingsRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/inventory': {
      id: '/$dealership/inventory'
      path: '/inventory'
      fullPath: '/$dealership/inventory'
      preLoaderRoute: typeof DealershipInventoryRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/feature-requests': {
      id: '/$dealership/feature-requests'
      path: '/feature-requests'
      fullPath: '/$dealership/feature-requests'
      preLoaderRoute: typeof DealershipFeatureRequestsRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/deal-packets': {
      id: '/$dealership/deal-packets'
      path: '/deal-packets'
      fullPath: '/$dealership/deal-packets'
      preLoaderRoute: typeof DealershipDealPacketsRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/dashboard': {
      id: '/$dealership/dashboard'
      path: '/dashboard'
      fullPath: '/$dealership/dashboard'
      preLoaderRoute: typeof DealershipDashboardRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/conversations': {
      id: '/$dealership/conversations'
      path: '/conversations'
      fullPath: '/$dealership/conversations'
      preLoaderRoute: typeof DealershipConversationsRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/inventory/': {
      id: '/$dealership/inventory/'
      path: '/'
      fullPath: '/$dealership/inventory/'
      preLoaderRoute: typeof DealershipInventoryIndexLazyRouteImport
      parentRoute: typeof DealershipInventoryRoute
    }
    '/$dealership/feature-requests/': {
      id: '/$dealership/feature-requests/'
      path: '/'
      fullPath: '/$dealership/feature-requests/'
      preLoaderRoute: typeof DealershipFeatureRequestsIndexRouteImport
      parentRoute: typeof DealershipFeatureRequestsRoute
    }
    '/$dealership/deal-packets/': {
      id: '/$dealership/deal-packets/'
      path: '/'
      fullPath: '/$dealership/deal-packets/'
      preLoaderRoute: typeof DealershipDealPacketsIndexRouteImport
      parentRoute: typeof DealershipDealPacketsRoute
    }
    '/$dealership/conversations/': {
      id: '/$dealership/conversations/'
      path: '/'
      fullPath: '/$dealership/conversations/'
      preLoaderRoute: typeof DealershipConversationsIndexRouteImport
      parentRoute: typeof DealershipConversationsRoute
    }
    '/$dealership/inventory/$vehicleId': {
      id: '/$dealership/inventory/$vehicleId'
      path: '/$vehicleId'
      fullPath: '/$dealership/inventory/$vehicleId'
      preLoaderRoute: typeof DealershipInventoryVehicleIdRouteImport
      parentRoute: typeof DealershipInventoryRoute
    }
    '/$dealership/feature-requests/$requestId': {
      id: '/$dealership/feature-requests/$requestId'
      path: '/$requestId'
      fullPath: '/$dealership/feature-requests/$requestId'
      preLoaderRoute: typeof DealershipFeatureRequestsRequestIdRouteImport
      parentRoute: typeof DealershipFeatureRequestsRoute
    }
    '/$dealership/documents/templates': {
      id: '/$dealership/documents/templates'
      path: '/documents/templates'
      fullPath: '/$dealership/documents/templates'
      preLoaderRoute: typeof DealershipDocumentsTemplatesRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/documents/new': {
      id: '/$dealership/documents/new'
      path: '/documents/new'
      fullPath: '/$dealership/documents/new'
      preLoaderRoute: typeof DealershipDocumentsNewRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/documents/$templateId': {
      id: '/$dealership/documents/$templateId'
      path: '/documents/$templateId'
      fullPath: '/$dealership/documents/$templateId'
      preLoaderRoute: typeof DealershipDocumentsTemplateIdRouteImport
      parentRoute: typeof DealershipRouteRoute
    }
    '/$dealership/deal-packets/templates': {
      id: '/$dealership/deal-packets/templates'
      path: '/templates'
      fullPath: '/$dealership/deal-packets/templates'
      preLoaderRoute: typeof DealershipDealPacketsTemplatesRouteImport
      parentRoute: typeof DealershipDealPacketsRoute
    }
    '/$dealership/deal-packets/presets': {
      id: '/$dealership/deal-packets/presets'
      path: '/presets'
      fullPath: '/$dealership/deal-packets/presets'
      preLoaderRoute: typeof DealershipDealPacketsPresetsRouteImport
      parentRoute: typeof DealershipDealPacketsRoute
    }
    '/$dealership/deal-packets/new': {
      id: '/$dealership/deal-packets/new'
      path: '/new'
      fullPath: '/$dealership/deal-packets/new'
      preLoaderRoute: typeof DealershipDealPacketsNewRouteImport
      parentRoute: typeof DealershipDealPacketsRoute
    }
    '/$dealership/deal-packets/$dealId': {
      id: '/$dealership/deal-packets/$dealId'
      path: '/$dealId'
      fullPath: '/$dealership/deal-packets/$dealId'
      preLoaderRoute: typeof DealershipDealPacketsDealIdRouteImport
      parentRoute: typeof DealershipDealPacketsRoute
    }
    '/$dealership/conversations/$threadId': {
      id: '/$dealership/conversations/$threadId'
      path: '/$threadId'
      fullPath: '/$dealership/conversations/$threadId'
      preLoaderRoute: typeof DealershipConversationsThreadIdRouteImport
      parentRoute: typeof DealershipConversationsRoute
    }
    '/$dealership/feature-requests/$requestId/': {
      id: '/$dealership/feature-requests/$requestId/'
      path: '/'
      fullPath: '/$dealership/feature-requests/$requestId/'
      preLoaderRoute: typeof DealershipFeatureRequestsRequestIdIndexRouteImport
      parentRoute: typeof DealershipFeatureRequestsRequestIdRoute
    }
    '/$dealership/documents/$templateId/': {
      id: '/$dealership/documents/$templateId/'
      path: '/'
      fullPath: '/$dealership/documents/$templateId/'
      preLoaderRoute: typeof DealershipDocumentsTemplateIdIndexRouteImport
      parentRoute: typeof DealershipDocumentsTemplateIdRoute
    }
    '/$dealership/deal-packets/templates/': {
      id: '/$dealership/deal-packets/templates/'
      path: '/'
      fullPath: '/$dealership/deal-packets/templates/'
      preLoaderRoute: typeof DealershipDealPacketsTemplatesIndexRouteImport
      parentRoute: typeof DealershipDealPacketsTemplatesRoute
    }
    '/$dealership/deal-packets/presets/': {
      id: '/$dealership/deal-packets/presets/'
      path: '/'
      fullPath: '/$dealership/deal-packets/presets/'
      preLoaderRoute: typeof DealershipDealPacketsPresetsIndexRouteImport
      parentRoute: typeof DealershipDealPacketsPresetsRoute
    }
    '/$dealership/deal-packets/$dealId/': {
      id: '/$dealership/deal-packets/$dealId/'
      path: '/'
      fullPath: '/$dealership/deal-packets/$dealId/'
      preLoaderRoute: typeof DealershipDealPacketsDealIdIndexRouteImport
      parentRoute: typeof DealershipDealPacketsDealIdRoute
    }
    '/$dealership/conversations/$threadId/': {
      id: '/$dealership/conversations/$threadId/'
      path: '/'
      fullPath: '/$dealership/conversations/$threadId/'
      preLoaderRoute: typeof DealershipConversationsThreadIdIndexRouteImport
      parentRoute: typeof DealershipConversationsThreadIdRoute
    }
    '/$dealership/documents/$templateId/fields': {
      id: '/$dealership/documents/$templateId/fields'
      path: '/fields'
      fullPath: '/$dealership/documents/$templateId/fields'
      preLoaderRoute: typeof DealershipDocumentsTemplateIdFieldsRouteImport
      parentRoute: typeof DealershipDocumentsTemplateIdRoute
    }
    '/$dealership/deal-packets/templates/$templateId': {
      id: '/$dealership/deal-packets/templates/$templateId'
      path: '/$templateId'
      fullPath: '/$dealership/deal-packets/templates/$templateId'
      preLoaderRoute: typeof DealershipDealPacketsTemplatesTemplateIdRouteImport
      parentRoute: typeof DealershipDealPacketsTemplatesRoute
    }
    '/$dealership/deal-packets/templates/$templateId/': {
      id: '/$dealership/deal-packets/templates/$templateId/'
      path: '/'
      fullPath: '/$dealership/deal-packets/templates/$templateId/'
      preLoaderRoute: typeof DealershipDealPacketsTemplatesTemplateIdIndexRouteImport
      parentRoute: typeof DealershipDealPacketsTemplatesTemplateIdRoute
    }
    '/$dealership/deal-packets/templates/$templateId/fields': {
      id: '/$dealership/deal-packets/templates/$templateId/fields'
      path: '/fields'
      fullPath: '/$dealership/deal-packets/templates/$templateId/fields'
      preLoaderRoute: typeof DealershipDealPacketsTemplatesTemplateIdFieldsRouteImport
      parentRoute: typeof DealershipDealPacketsTemplatesTemplateIdRoute
    }
  }
}

interface DealershipConversationsThreadIdRouteChildren {
  DealershipConversationsThreadIdIndexRoute: typeof DealershipConversationsThreadIdIndexRoute
}

const DealershipConversationsThreadIdRouteChildren: DealershipConversationsThreadIdRouteChildren =
  {
    DealershipConversationsThreadIdIndexRoute:
      DealershipConversationsThreadIdIndexRoute,
  }

const DealershipConversationsThreadIdRouteWithChildren =
  DealershipConversationsThreadIdRoute._addFileChildren(
    DealershipConversationsThreadIdRouteChildren,
  )

interface DealershipConversationsRouteChildren {
  DealershipConversationsThreadIdRoute: typeof DealershipConversationsThreadIdRouteWithChildren
  DealershipConversationsIndexRoute: typeof DealershipConversationsIndexRoute
}

const DealershipConversationsRouteChildren: DealershipConversationsRouteChildren =
  {
    DealershipConversationsThreadIdRoute:
      DealershipConversationsThreadIdRouteWithChildren,
    DealershipConversationsIndexRoute: DealershipConversationsIndexRoute,
  }

const DealershipConversationsRouteWithChildren =
  DealershipConversationsRoute._addFileChildren(
    DealershipConversationsRouteChildren,
  )

interface DealershipDealPacketsDealIdRouteChildren {
  DealershipDealPacketsDealIdIndexRoute: typeof DealershipDealPacketsDealIdIndexRoute
}

const DealershipDealPacketsDealIdRouteChildren: DealershipDealPacketsDealIdRouteChildren =
  {
    DealershipDealPacketsDealIdIndexRoute:
      DealershipDealPacketsDealIdIndexRoute,
  }

const DealershipDealPacketsDealIdRouteWithChildren =
  DealershipDealPacketsDealIdRoute._addFileChildren(
    DealershipDealPacketsDealIdRouteChildren,
  )

interface DealershipDealPacketsPresetsRouteChildren {
  DealershipDealPacketsPresetsIndexRoute: typeof DealershipDealPacketsPresetsIndexRoute
}

const DealershipDealPacketsPresetsRouteChildren: DealershipDealPacketsPresetsRouteChildren =
  {
    DealershipDealPacketsPresetsIndexRoute:
      DealershipDealPacketsPresetsIndexRoute,
  }

const DealershipDealPacketsPresetsRouteWithChildren =
  DealershipDealPacketsPresetsRoute._addFileChildren(
    DealershipDealPacketsPresetsRouteChildren,
  )

interface DealershipDealPacketsTemplatesTemplateIdRouteChildren {
  DealershipDealPacketsTemplatesTemplateIdFieldsRoute: typeof DealershipDealPacketsTemplatesTemplateIdFieldsRoute
  DealershipDealPacketsTemplatesTemplateIdIndexRoute: typeof DealershipDealPacketsTemplatesTemplateIdIndexRoute
}

const DealershipDealPacketsTemplatesTemplateIdRouteChildren: DealershipDealPacketsTemplatesTemplateIdRouteChildren =
  {
    DealershipDealPacketsTemplatesTemplateIdFieldsRoute:
      DealershipDealPacketsTemplatesTemplateIdFieldsRoute,
    DealershipDealPacketsTemplatesTemplateIdIndexRoute:
      DealershipDealPacketsTemplatesTemplateIdIndexRoute,
  }

const DealershipDealPacketsTemplatesTemplateIdRouteWithChildren =
  DealershipDealPacketsTemplatesTemplateIdRoute._addFileChildren(
    DealershipDealPacketsTemplatesTemplateIdRouteChildren,
  )

interface DealershipDealPacketsTemplatesRouteChildren {
  DealershipDealPacketsTemplatesTemplateIdRoute: typeof DealershipDealPacketsTemplatesTemplateIdRouteWithChildren
  DealershipDealPacketsTemplatesIndexRoute: typeof DealershipDealPacketsTemplatesIndexRoute
}

const DealershipDealPacketsTemplatesRouteChildren: DealershipDealPacketsTemplatesRouteChildren =
  {
    DealershipDealPacketsTemplatesTemplateIdRoute:
      DealershipDealPacketsTemplatesTemplateIdRouteWithChildren,
    DealershipDealPacketsTemplatesIndexRoute:
      DealershipDealPacketsTemplatesIndexRoute,
  }

const DealershipDealPacketsTemplatesRouteWithChildren =
  DealershipDealPacketsTemplatesRoute._addFileChildren(
    DealershipDealPacketsTemplatesRouteChildren,
  )

interface DealershipDealPacketsRouteChildren {
  DealershipDealPacketsDealIdRoute: typeof DealershipDealPacketsDealIdRouteWithChildren
  DealershipDealPacketsNewRoute: typeof DealershipDealPacketsNewRoute
  DealershipDealPacketsPresetsRoute: typeof DealershipDealPacketsPresetsRouteWithChildren
  DealershipDealPacketsTemplatesRoute: typeof DealershipDealPacketsTemplatesRouteWithChildren
  DealershipDealPacketsIndexRoute: typeof DealershipDealPacketsIndexRoute
}

const DealershipDealPacketsRouteChildren: DealershipDealPacketsRouteChildren = {
  DealershipDealPacketsDealIdRoute:
    DealershipDealPacketsDealIdRouteWithChildren,
  DealershipDealPacketsNewRoute: DealershipDealPacketsNewRoute,
  DealershipDealPacketsPresetsRoute:
    DealershipDealPacketsPresetsRouteWithChildren,
  DealershipDealPacketsTemplatesRoute:
    DealershipDealPacketsTemplatesRouteWithChildren,
  DealershipDealPacketsIndexRoute: DealershipDealPacketsIndexRoute,
}

const DealershipDealPacketsRouteWithChildren =
  DealershipDealPacketsRoute._addFileChildren(
    DealershipDealPacketsRouteChildren,
  )

interface DealershipFeatureRequestsRequestIdRouteChildren {
  DealershipFeatureRequestsRequestIdIndexRoute: typeof DealershipFeatureRequestsRequestIdIndexRoute
}

const DealershipFeatureRequestsRequestIdRouteChildren: DealershipFeatureRequestsRequestIdRouteChildren =
  {
    DealershipFeatureRequestsRequestIdIndexRoute:
      DealershipFeatureRequestsRequestIdIndexRoute,
  }

const DealershipFeatureRequestsRequestIdRouteWithChildren =
  DealershipFeatureRequestsRequestIdRoute._addFileChildren(
    DealershipFeatureRequestsRequestIdRouteChildren,
  )

interface DealershipFeatureRequestsRouteChildren {
  DealershipFeatureRequestsRequestIdRoute: typeof DealershipFeatureRequestsRequestIdRouteWithChildren
  DealershipFeatureRequestsIndexRoute: typeof DealershipFeatureRequestsIndexRoute
}

const DealershipFeatureRequestsRouteChildren: DealershipFeatureRequestsRouteChildren =
  {
    DealershipFeatureRequestsRequestIdRoute:
      DealershipFeatureRequestsRequestIdRouteWithChildren,
    DealershipFeatureRequestsIndexRoute: DealershipFeatureRequestsIndexRoute,
  }

const DealershipFeatureRequestsRouteWithChildren =
  DealershipFeatureRequestsRoute._addFileChildren(
    DealershipFeatureRequestsRouteChildren,
  )

interface DealershipInventoryRouteChildren {
  DealershipInventoryVehicleIdRoute: typeof DealershipInventoryVehicleIdRoute
  DealershipInventoryIndexLazyRoute: typeof DealershipInventoryIndexLazyRoute
}

const DealershipInventoryRouteChildren: DealershipInventoryRouteChildren = {
  DealershipInventoryVehicleIdRoute: DealershipInventoryVehicleIdRoute,
  DealershipInventoryIndexLazyRoute: DealershipInventoryIndexLazyRoute,
}

const DealershipInventoryRouteWithChildren =
  DealershipInventoryRoute._addFileChildren(DealershipInventoryRouteChildren)

interface DealershipDocumentsTemplateIdRouteChildren {
  DealershipDocumentsTemplateIdFieldsRoute: typeof DealershipDocumentsTemplateIdFieldsRoute
  DealershipDocumentsTemplateIdIndexRoute: typeof DealershipDocumentsTemplateIdIndexRoute
}

const DealershipDocumentsTemplateIdRouteChildren: DealershipDocumentsTemplateIdRouteChildren =
  {
    DealershipDocumentsTemplateIdFieldsRoute:
      DealershipDocumentsTemplateIdFieldsRoute,
    DealershipDocumentsTemplateIdIndexRoute:
      DealershipDocumentsTemplateIdIndexRoute,
  }

const DealershipDocumentsTemplateIdRouteWithChildren =
  DealershipDocumentsTemplateIdRoute._addFileChildren(
    DealershipDocumentsTemplateIdRouteChildren,
  )

interface DealershipRouteRouteChildren {
  DealershipConversationsRoute: typeof DealershipConversationsRouteWithChildren
  DealershipDashboardRoute: typeof DealershipDashboardRoute
  DealershipDealPacketsRoute: typeof DealershipDealPacketsRouteWithChildren
  DealershipFeatureRequestsRoute: typeof DealershipFeatureRequestsRouteWithChildren
  DealershipInventoryRoute: typeof DealershipInventoryRouteWithChildren
  DealershipSettingsRoute: typeof DealershipSettingsRoute
  DealershipTeamRoute: typeof DealershipTeamRoute
  DealershipWebsiteRoute: typeof DealershipWebsiteRoute
  DealershipAnalyticsLazyRoute: typeof DealershipAnalyticsLazyRoute
  DealershipAppointmentsLazyRoute: typeof DealershipAppointmentsLazyRoute
  DealershipCustomersLazyRoute: typeof DealershipCustomersLazyRoute
  DealershipSeoLazyRoute: typeof DealershipSeoLazyRoute
  DealershipIndexRoute: typeof DealershipIndexRoute
  DealershipDocumentsTemplateIdRoute: typeof DealershipDocumentsTemplateIdRouteWithChildren
  DealershipDocumentsNewRoute: typeof DealershipDocumentsNewRoute
  DealershipDocumentsTemplatesRoute: typeof DealershipDocumentsTemplatesRoute
}

const DealershipRouteRouteChildren: DealershipRouteRouteChildren = {
  DealershipConversationsRoute: DealershipConversationsRouteWithChildren,
  DealershipDashboardRoute: DealershipDashboardRoute,
  DealershipDealPacketsRoute: DealershipDealPacketsRouteWithChildren,
  DealershipFeatureRequestsRoute: DealershipFeatureRequestsRouteWithChildren,
  DealershipInventoryRoute: DealershipInventoryRouteWithChildren,
  DealershipSettingsRoute: DealershipSettingsRoute,
  DealershipTeamRoute: DealershipTeamRoute,
  DealershipWebsiteRoute: DealershipWebsiteRoute,
  DealershipAnalyticsLazyRoute: DealershipAnalyticsLazyRoute,
  DealershipAppointmentsLazyRoute: DealershipAppointmentsLazyRoute,
  DealershipCustomersLazyRoute: DealershipCustomersLazyRoute,
  DealershipSeoLazyRoute: DealershipSeoLazyRoute,
  DealershipIndexRoute: DealershipIndexRoute,
  DealershipDocumentsTemplateIdRoute:
    DealershipDocumentsTemplateIdRouteWithChildren,
  DealershipDocumentsNewRoute: DealershipDocumentsNewRoute,
  DealershipDocumentsTemplatesRoute: DealershipDocumentsTemplatesRoute,
}

const DealershipRouteRouteWithChildren = DealershipRouteRoute._addFileChildren(
  DealershipRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DealershipRouteRoute: DealershipRouteRouteWithChildren,
  CheckDealershipRoute: CheckDealershipRoute,
  CompleteProfileRoute: CompleteProfileRoute,
  CreateDealershipRoute: CreateDealershipRoute,
  DealershipsRoute: DealershipsRoute,
  DemoRoute: DemoRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TestRoute: TestRoute,
  TestFieldsRoute: TestFieldsRoute,
  ForgotPasswordLazyRoute: ForgotPasswordLazyRoute,
  SignupLazyRoute: SignupLazyRoute,
  FormTokenRoute: FormTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
